export const HomebotLogoV2 = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
      <circle cx='24' cy='24' r='24' fill='#1E1C23' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24 44.2791C35.1998 44.2791 44.2791 35.1998 44.2791 24C44.2791 12.8002 35.1998 3.72093 24 3.72093C12.8002 3.72093 3.72093 12.8002 3.72093 24C3.72093 35.1998 12.8002 44.2791 24 44.2791ZM24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z'
        fill='url(#paint0_linear_2278_20976)'
      />
      <g clipPath='url(#clip0_2278_20976)'>
        <circle cx='24.1183' cy='15.8449' r='6.60465' fill='#741D4A' />
        <circle cx='24.1182' cy='15.8438' r='4.74419' fill='#DB1E78' />
      </g>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M25.7431 25.4811C25.7431 27.0074 26.9792 28.2433 28.5051 28.2433C30.031 28.2433 31.2671 27.0051 31.2671 25.4811C31.2671 23.9548 30.031 22.7166 28.5051 22.7166C26.9815 22.7166 25.7431 23.9525 25.7431 25.4811ZM16.7848 25.4811C16.7848 27.0074 18.0208 28.2433 19.5467 28.2433C21.0726 28.2433 22.3087 27.0051 22.3087 25.4811C22.3087 23.9548 21.0726 22.7166 19.5467 22.7166C18.0208 22.7166 16.7848 23.9525 16.7848 25.4811ZM19.8946 35.7873H16.8729C15.8827 35.7873 15.0803 34.9835 15.0803 33.9915V30.8336H14.0135C13.4802 30.8336 13.0488 30.4015 13.0488 29.8672V25.9573C13.0488 25.423 13.4802 24.9909 14.0135 24.9909H15.0803V21.1577C15.0803 20.1658 15.8827 19.3643 16.8729 19.3643H23.4867V18.2677C22.1904 18.0052 21.2164 16.8599 21.2164 15.4869C21.2164 13.9188 22.4849 12.6504 24.0503 12.6504C25.6156 12.6504 26.8864 13.9188 26.8864 15.4869C26.8864 16.8994 25.8545 18.0703 24.5025 18.2887V19.3643H31.1372C32.1274 19.3643 32.9298 20.1681 32.9298 21.1577V24.9909H33.9826C34.5183 24.9909 34.9497 25.423 34.9497 25.9573V29.8672C34.9497 30.4015 34.516 30.8336 33.9826 30.8336H32.9298V33.9915C32.9298 34.9835 32.1251 35.7873 31.1372 35.7873H28.141H19.8946ZM18.5472 30.7988C17.942 30.7988 17.4503 31.3006 17.4503 31.8999V32.0672C17.4503 32.6759 17.9443 33.1684 18.5472 33.1684H29.7574C30.3626 33.1684 30.8543 32.6666 30.8543 32.0672V31.8999C30.8543 31.2913 30.3603 30.7988 29.7574 30.7988H18.5472Z'
        fill='#FAF5F8'
      />
      <defs>
        <linearGradient
          id='paint0_linear_2278_20976'
          x1='34.9714'
          y1='3.65714'
          x2='11.2'
          y2='44.5714'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.44' stopColor='#F51E84' />
          <stop offset='0.83' stopColor='#CE14BE' />
        </linearGradient>
        <clipPath id='clip0_2278_20976'>
          <rect width='13.2093' height='13.2093' fill='white' transform='translate(17.5137 8.92969)' />
        </clipPath>
      </defs>
    </svg>
  )
}
